<template>
     <v-container fluid grid-list-md class="px-0 pt-0 map-asset-list-container scrollbar">      
      <v-layout column px-0 >        
        <v-flex xs12 justify-center>
            <v-tabs 
                grow  
                dark 
                v-model="tabs"
                color="primary lighten-1"
            >
                <v-tab  >
                    Groep
                </v-tab>
                <v-tab >
                    Status
                </v-tab>
            </v-tabs>            
            <v-tabs-items v-show="tabs == 0">
                
                    <div class="group-header grey lighten-4">
                        <div class="px-2" style="width: 20px;" @click="hideAllGroups()">
                            <i  class="fas fa-eye" ></i>                        
                        </div>
                        <!-- <div class="px-2" style="width: 20px;" v-else @click="showGroup(assets[0].group)">                        
                            <i class="fas fa-eye-slash grey--text" ></i>
                        </div> -->
                        <div class="group-name"><b>{{this.generateHideAllText()}}</b></div>         
                        <div class="d-flex">&nbsp;</div>             
                    </div>
                    <div class="asset-container">
                    </div>

                <div v-for="group in sortedGroups" :key="`${group.name}_${group.visible}`">
                    <div class="group-header grey lighten-4" v-if="group.visible">
                        <div class="px-2" style="width: 20px;" v-if="!groupIsHidden(group.data[0].group)" @click="hideGroup(group.name)">
                            <i  class="fas fa-eye" ></i>                        
                        </div>
                        <!-- <div class="px-2" style="width: 20px;" v-else @click="showGroup(assets[0].group)">                        
                            <i class="fas fa-eye-slash grey--text" ></i>
                        </div> -->
                        <div class="group-name " @click="groupSelected(group.name)">{{group.name}}</div>
                        <div class="group-size d-flex" @click="groupSelected(group.name)">{{group.data.length}}</div>                    
                    </div>
                    <div class="group-header grey lighten-4" v-else>                        
                        <div class="px-2" style="width: 20px;" @click="showGroup(group.name)">                        
                            <i class="fas fa-eye-slash grey--text" ></i>
                        </div>
                        <div class="group-name " @click="groupSelected(group.name)">{{group.name}}</div>
                        
                    </div>
                    <div class="asset-container">
                        <div v-if="selectedGroup == group.name && group.visible" >
                            <div v-for="asset in group.data" :key="`G_${asset.id}`" :style="`border-left: ${statusColor(asset)} solid 10px;`" class="asset-content" @click="selectAsset(asset)">
                                <div class="asset-content-left">
                                    <div style="display: flex; justify-content: space-between;">
                                        <div class="asset-name">{{asset.name}}</div>
                                        
                                    
                                    </div>
                                    <div class="asset-primary-content" v-if="getPrimaryCustomField(asset)">{{getPrimaryCustomField(asset).name}}: {{getPrimaryCustomField(asset).value}}{{getPrimaryCustomField(asset).typeShort}}</div>
                                    <div class="asset-location">{{asset.street}}, {{asset.city}}</div>
                                </div>
                                <div class="asset-content-right" v-if="asset.hasRoutes">
                                    <div v-if="!asset.movementStatus" class="route-icon"><i class='fas fa-parking blue--text'></i></div>
                                    <div v-else class="route-icon"><i class='fas fa-play green--text'></i></div>
                                </div>
                                
                            </div>
                        </div>
                        

                    </div>
                </div>
                <!-- <div v-for="group of mapAssetGroupsHidden" :key="group.id">
                    <div class="group-header grey lighten-3" >
                        
                        <div class="px-2" style="width: 20px;" @click="showGroup(group)">                        
                            <i class="fas fa-eye-slash grey--text" ></i>
                        </div>
                        <div class="group-name " @click="groupSelected(group)">{{group.name}}</div>
                        
                    </div>
                </div> -->
            </v-tabs-items>
            <v-tabs-items v-show="tabs == 1">
                <div v-for="(assets,group) in byStatus" :key="group">
                <div class="group-header grey lighten-3" @click="groupSelected(group)">
                    <div class="group-name">{{group}}</div><div class="group-size">{{assets.length}}</div>                    
                </div>
                <div class="asset-container">
                    <div v-if="selectedGroup == group">
                        <div v-for="asset in assets" :key="`S_${asset.id}`" :style="`border-left: ${statusColor(asset)} solid 10px;`" class="asset-content" @click="selectAsset(asset)">
                            <div class="asset-content-left">
                                <div class="asset-name">{{asset.name}}</div>
                                <div class="asset-location">{{asset.street}}, {{asset.city}}</div>
                            </div>
                            <div class="asset-content-right" v-if="asset.hasRoutes">
                                <div v-if="!asset.movementStatus" class="route-icon"><i class='fas fa-parking blue--text'></i></div>
                                <div v-else class="route-icon"><i class='fas fa-play green--text'></i></div>
                            </div>
                            
                        </div>
                    </div>
                    
                    

                </div>
                </div>
            </v-tabs-items>
       </v-flex>
      </v-layout>
     </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import * as types from "../../store/types"
import _ from "lodash"
import ColorMixin from '../../plugins/mixins/ColorMixin.js'

export default {
    props: ['assets'],
    mixins:[ ColorMixin ],
    data(){
        return {
            tabs: 0,
            selectedGroup: null
        }
    },
    computed:{
        byGroups(){
            let byGroups =  _.groupBy(this.assets, (ele) =>  ele.group.name )
            //console.log(byGroups)
            //console.log(this.mapAssetGroupsHidden)
            return byGroups
            
        },
        sortedGroups(){
            //console.log(Object.entries(this.byGroups))
            let ret = []
            for(let [i,g] of Object.entries(this.byGroups)){
                let hidden = this.mapAssetGroupsHidden.find((ele) => { return ele == i})
                if(hidden){
                    ret.push({name: i, visible: false, data:g })
                }
                else{
                    ret.push({name: i, visible: true, data:g })
                }
                
                
            }
            for(let hiddenGroup of this.mapAssetGroupsHidden ){
              //console.log(hiddenGroup)
                 ret.push({name: hiddenGroup, visible: false})
             }
            
            ret.sort((a, b) => (a.name > b.name) ? 1 : -1)
            return ret
            //console.log("x", visible)
        },
        byStatus(){
            return _.groupBy(this.assets, (ele) => 
            {
                if(ele.statusType.toLowerCase() == "none")
                    ele.statusType = "OK";

                return ele.statusType 
            }
           );
            
        },
        hiddenGroups(){
            let ret = []
            for(let [i,g] of Object.entries(this.byGroups)){
                let hidden = this.mapAssetGroupsHidden.find((ele) => { return ele == i})
                if(hidden)
                    ret.push({name: i, visible: false, data:g })
            }

            return ret;
        },
        ...mapGetters({
            mapAssetGroupsHidden:types.MAP_ASSET_GROUPS_HIDDEN
        })
    },
    methods:{
        
        hideGroup(group){
            //console.log("HIDE", group)
            this.$store.dispatch(types.MAP_ASSET_HIDE_GROUP, {data: { group: group, hide:true }})
        },
        showGroup(group){
            //console.log("SHOW", group)
            this.$store.dispatch(types.MAP_ASSET_HIDE_GROUP, {data: { group: group, hide:false }})
        },
        groupIsHidden(group){
            let found = this.mapAssetGroupsHidden.find((ele) => ele == group.id)
            if(found){
                return true
            }
            return false
        },
        groupSelected(group){
            if(group == this.selectedGroup){
                this.selectedGroup = null
            }
            else{
                this.selectedGroup = group
            }
            
        },
        statusColor(asset){
            if(asset.statusColor){
                return asset.statusColor;
            }
            if(asset.statusCode == "OK"){
                return this.successColor
            }
            
            else if(asset.statusCode == "ERROR_WITH_ACTION"){
                return this.errorWithActionColor
            }
            else if(asset.statusCode == "ERROR"){
                return  this.errorColor
            }

            else if(asset.statusCode == "ACTION"){
                return  this.actionColor
            }
        },
        selectAsset(asset){
            this.$emit('assetSelected', asset);
        },
        hideAllGroups(){
            let groups = this.sortedGroups; 
            let hideAll = true; // Default state = hide everything
   
             // We check if at least one group is hidden. If so, we show all. 
            if(this.getAmountOfHiddenGroups() > 0)
               hideAll = false;  

            // Determine if we should hide/show the groups. 
            // If at least one group is hidden we show all.
             for(let arrayNumber in groups){
                 let group  = groups[arrayNumber];
              
                if(hideAll)
                    this.hideGroup(group.name);
                else 
                    this.showGroup(group.name);
                    
            }
        },
        getAmountOfHiddenGroups(){
            let amount  = 0;
            for(let arrayNumber in this.sortedGroups){
            
                 let group  = this.sortedGroups[arrayNumber];
                
                 if(typeof group.data === "undefined")
                    amount++;
            }
            return parseInt(amount);
        },
        generateHideAllText(){
            let hideAllText = "Verberg alles";
            let showAllText = "Toon alles"

            if(this.getAmountOfHiddenGroups() == 0)
                return hideAllText;
            else
                return showAllText;
                
        },
        getPrimaryCustomField(a){
            if(a.customFields && a.customFields.length > 0){
                let primary = a.customFields.find((ele) => {
                    return ele.primary
                } )
                return primary
            }
            return null
        }
    }
}
</script>
<style scoped>
    .map-asset-list-container{
        background-color: rgba(255,255,255,0.6);
    }

    .asset-container{
        border-bottom: 1px solid #777;
    }

    .group-header{
        padding: 2px 2px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #777;
        cursor: pointer;
        align-content: center;
        align-items: center;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .group-name{
        padding: 4px 4px;
        text-transform: uppercase;
        color: #777;
        font-weight: 600;
        flex:1;
        padding-left: 18px;
        
    }

    .group-size{
        display: flex;
        padding: 4px 9px;
        margin: 4px 4px;
        width: 58px;
        text-align: center;
        justify-content: center;
        border-radius: 3px;
        background-color: rgb(175, 175, 175);
        color: #fff;
    }

    .asset-content{
        padding: 10px 12px;        
        border: 1px solid #ddd;
        border-bottom: none;
        display: flex;
        cursor: pointer;
        background-color: rgba(255,255,255,0.8);
        
    }

    .asset-name{
        font-size: 16px;
        font-weight: 500;
    }

    .asset-location{
        font-size: 14px;
        font-weight: 300;
    }

    .asset-content-right{
        width: 20px;
        flex :1,0;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
    }

    .asset-content-left{
        width: 20px;
        flex: 1;
    }

    .route-icon{
        font-size: 20px;
    }

    .asset-primary-content{
        color: #212121;
        font-weight: 600;
        
    }
</style>
